import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  closeDrawer,
  openDrawer,
  toggleDrawer,
  closeHistoryDrawer,
  openHistoryDrawer,
  toggleHistoryDrawer,
} from ".";

export const useDrawer = () => {
  const dispatch = useDispatch();
  const drawerState = useSelector((state) => state.drawer);

  const handleCloseDrawer = useCallback(() => {
    return dispatch(closeDrawer());
  }, [dispatch]);

  const handleOpenDrawer = useCallback(() => {
    return dispatch(openDrawer());
  }, [dispatch]);

  const handleToggleDrawer = useCallback(() => {
    return dispatch(toggleDrawer());
  }, [dispatch]);

  const handleCloseHistoryDrawer = useCallback(() => {
    return dispatch(closeHistoryDrawer());
  }, [dispatch]);

  const handleOpenHistoryDrawer = useCallback(() => {
    return dispatch(openHistoryDrawer());
  }, [dispatch]);

  const handleToggleHistoryDrawer = useCallback(() => {
    return dispatch(toggleHistoryDrawer());
  }, [dispatch]);

  return {
    // State
    showDrawer: drawerState.showDrawer,
    showHistoryDrawer: drawerState.showHistoryDrawer,

    // Actions
    closeDrawer: handleCloseDrawer,
    openDrawer: handleOpenDrawer,
    toggleDrawer: handleToggleDrawer,
    closeHistoryDrawer: handleCloseHistoryDrawer,
    openHistoryDrawer: handleOpenHistoryDrawer,
    toggleHistoryDrawer: handleToggleHistoryDrawer,
  };
};
